import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { CiSearch } from "react-icons/ci";
import { useLocation, useNavigate } from "react-router-dom";
import { getNewsData } from "../api/home";
import useSitePanel from "../store/useSitePanel";
import "../styles/news.css";
import ListMenu from "./ListMenu";
import NewsCard from "./NewsCard";

function SiteHeader() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const statusPanel = useSitePanel((state) => state.status);
  const togglePanel = useSitePanel((state) => state.toggle);
  const panelSearchRef = useRef(null);
  const currentLanguage = i18n.language;
  const menuLanguage = [
    { code: "th", text: "ไทย" },
    { code: "en", text: "Eng" },
  ];

  console.log("currentLanguage", currentLanguage);

  const [scrollPosition, setScrollPosition] = useState(0);
  const [inputValue, setInputValue] = useState("");
  const [news, setNews] = useState([]);
  const [otherNews, setOtherNews] = useState([]);

  const [submitSearch, setSubmitSearch] = useState(false);

  const [isScrolled, setIsScrolled] = useState(true); // fixed to true to disable scroll effect
  const [isSearch, setIsSearch] = useState(false);
  const [menuFontSize, setMenuFontSize] = useState([
    { active: false, code: "small" },
    { active: true, code: "medium" },
    { active: false, code: "large" },
  ]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("language", lng);
    navigate(0);
  };

  const updateActiveFontSize = (targetCode) => {
    setMenuFontSize(
      menuFontSize.map((item) =>
        item.code === targetCode
          ? { ...item, active: true }
          : { ...item, active: false }
      )
    );
  };

  const increaseFontSize = (type) => {
    updateActiveFontSize(type);
    switch (type) {
      case "small":
        document.body.classList.add("smaller");
        document.body.classList.remove("bigger");
        break;
      case "large":
        document.body.classList.add("bigger");
        document.body.classList.remove("smaller");
        break;
      default:
        document.body.classList.remove("bigger");
        document.body.classList.remove("smaller");
        break;
    }
  };

  const toggleSearchPanel = () => {
    setIsSearch((prev) => !prev);
  };

  const handleChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleSubmit = async (searchTerm) => {
    try {
      setSubmitSearch(true);

      const resp = await getNewsData();

      const filter = resp.filter((item) => {
        return item.title.toLowerCase().includes(searchTerm.toLowerCase());
      });

      const ncsa = filter.filter((item) => item.category.includes("news"));
      const oths = filter.filter((item) => !item.category.includes("news"));

      setNews(ncsa);
      setOtherNews(oths);
    } catch (error) {
      console.warn(error);
    }
  };

  const searchListRelated = [
    { name: "ประกาศจัดซื้อจัดจ้าง" },
    { name: "กิจกรรม" },
    { name: "ประชุมลประจำปี" },
    { name: "สกมช" },
  ];

  useEffect(() => {
    if (isSearch) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isSearch]);

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);

  const displaySearchPanel = (
    <div
      ref={panelSearchRef}
      className={`site-search-panel ${isSearch ? "show" : ""}  z-[99]`}
    >
      {isSearch && (
        <div className="backdrop  " onClick={() => setIsSearch(false)} />
      )}
      <div className="container mx-auto ">
        <div className="header">
          <span className="header-line" role="presentation" />
          <h2 className="header-title">{t("search")}</h2>
          <span className="header-line" role="presentation" />
        </div>
      </div>
      <div className="container mx-auto ">
        <div className="search-bar">
          <form
            onSubmit={(ev) => {
              ev.preventDefault();
              handleSubmit(inputValue);
            }}
            className="search-bar-form"
          >
            <div className="search-bar-group">
              <CiSearch className="search-bar-icon" />
              <input
                type="text"
                id="searchText"
                value={inputValue}
                onChange={handleChange}
                className="search-bar-input"
              />
            </div>
            <button type="submit" className="button-red-main text-md">
              {t("search")}
            </button>
          </form>
        </div>
        <div className="search-related">
          <h3 className="search-related-header">{t("searchRelated")}</h3>
          <div className="search-related-popular">
            {searchListRelated.map((item, index) => (
              <button
                key={index}
                className="button-chip text-md"
                onClick={() => {
                  setInputValue(item.name);
                  handleSubmit(item.name);
                }}
              >
                {item.name}
              </button>
            ))}
          </div>
        </div>
      </div>
      {submitSearch && (
        <div className="container mx-auto ">
          <div className="news-container">
            <h4 className="news-title text-xl">ข่าว สกมช.</h4>
            <div className="flex flex-wrap" onClick={() => setIsSearch(false)}>
              {news.length ? (
                news.map((el) => (
                  <NewsCard
                    key={el?._id}
                    url={`/news/${el?._id}`}
                    title={el?.title}
                    image={
                      el?.newsimage?.path ??
                      "https://via.placeholder.com/270x150"
                    }
                    datetime={new Date(el?.showdate).getTime()}
                  />
                ))
              ) : (
                <div className="">
                  <h4 className="ms-5 text-xl text-neutral-700">ไม่พบข้อมูล</h4>
                </div>
              )}
            </div>
          </div>

          {!!otherNews.length && (
            <div className="news-container">
              <h4 className="news-title text-xl">ข่าว อื่น ๆ ที่น่าสนใจ</h4>
              <div
                className="flex flex-wrap"
                onClick={() => setIsSearch(false)}
              >
                {otherNews.map((el) => (
                  <NewsCard
                    key={el?._id}
                    url={`/news/${el?._id}`}
                    title={el?.title}
                    image={
                      el?.newsimage?.path ??
                      "https://via.placeholder.com/270x150"
                    }
                    datetime={new Date(el?.showdate).getTime()}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );

  return (
    <header className={`site-header `}>
      <div className="site-header__container flex justify-between ">
        <div className="flex items-center">
          <div
            onClick={togglePanel}
            id="hamburger_menu"
            className={`md:hidden mr-4 ${statusPanel ? "open" : ""}`}
          >
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div className="site-logo">
            <img
              className="w-[90px]"
              src={`${"/images/logo-color-brand.png"}`}
              alt="ncsa"
            />
          </div>
        </div>
        <div className="flex items-center">
          <div className="site-header__box">
            <span className={"text-dark-600 text-md mr-2 hidden md:block"}>
              {t("fontSizeText")}
            </span>
            {menuFontSize.map((item, index) => (
              <button
                key={index}
                className={`button-fontsize hidden md:flex ${
                  item.active ? "active" : ""
                }`}
                disabled={item.active}
                onClick={() => increaseFontSize(item.code)}
              >
                <span
                  className={`${item.active ? "text-white" : "text-dark-600"}`}
                >
                  {t("fontText")}
                </span>
              </button>
            ))}
          </div>
          <div className="site-header__box ">
            <button
              className="button-search "
              onClick={() => navigate("/search")}
            >
              <CiSearch color="black" />
              <span className="text-dark-600">{t("search")}</span>
            </button>
          </div>
          <div className="shadow-md rounded-md p-0">
            {menuLanguage.map((item, index) => (
              <button
                key={index}
                className={`button-language ${
                  currentLanguage === item.code ? "active" : ""
                } `}
                onClick={() => changeLanguage(item.code)}
              >
                <span>{item.text}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className="bg-base">
        <div className="site-header__container justify-center hidden md:flex ">
          <ListMenu className="site-navigation" />
        </div>
      </div>
      {displaySearchPanel}
    </header>
  );
}

export default SiteHeader;
